import { FormControl, VStack } from '@bonusly/design-system';
import { useAnalytics } from '@bonusly/who-am-i';

import { Award } from '../../../../../../types/bonus';
import { AwardOption } from './AwardOption';
import { useAwardModalState } from './state';

export const AwardSelectionList = () => {
	const { awards, group, selectAward, selectedAward, isTemplatedAward } = useAwardModalState();
	const { track } = useAnalytics();

	const handleSelectAwardOption = (award: Award) => {
		track('Award Selection', {
			award_name: award.giver.first_name,
			award_type: isTemplatedAward ? 'Templated' : 'Non Templated',
			budget_timeframe: award.budget_period,
		});
		selectAward(award);
	};
	return (
		<FormControl>
			<VStack spacing={0}>
				{awards.map((award) => {
					return <AwardOption key={award.id} award={award} group={group} isChecked={award === selectedAward} onClick={() => handleSelectAwardOption(award)} />;
				})}
			</VStack>
		</FormControl>
	);
};
